import { styled } from '@linaria/react';

export const Skeleton = styled.div`
  background: linear-gradient(90deg, #1a1a1a 0%, #404040 25%, #1a1a1a 100%);
  background-size: 200% 100%;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: 0 -200%;
    }
  }

  animation: shimmer 1.5s linear infinite;
  border-radius: 12px;
`;
